import { type ReactElement, useEffect, useRef, useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import { NoResult } from '~/components/Global/Elements/NoResult/NoResult'
import { Shimmer } from '~/components/Global/Elements/Shimmer/Shimmer'
import { viewerFrame, viewerPage } from './PublicShortlist.css'

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

type ShortlistPdfPreviewProps = {
  url: string
}

export const ShortlistPdfPreview = ({
  url
}: ShortlistPdfPreviewProps): ReactElement => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [width, setWidth] = useState<number>()
  const [pageCount, setPageCount] = useState(0)
  const pageNumbers = Array.from(
    { length: pageCount },
    (_, pageIndex) => pageIndex + 1
  )

  useEffect(() => {
    const container = containerRef.current
    if (!container) return
    const observer = new ResizeObserver(([entry]) => {
      if (entry) setWidth(entry.contentRect.width)
    })
    observer.observe(container)
    return () => observer.disconnect()
  }, [])

  return (
    <div ref={containerRef} className={viewerFrame}>
      <Document
        file={url}
        onLoadSuccess={({ numPages }) => setPageCount(numPages)}
        loading={<Shimmer height={400} width="100%" />}
        error={<NoResult isError message="Le CV n'a pas pu être affiché." />}
      >
        {pageNumbers.map((pageNumber) => (
          <Page
            key={pageNumber}
            className={viewerPage}
            pageNumber={pageNumber}
            width={width}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        ))}
      </Document>
    </div>
  )
}
